import script from "./reportSkzw.vue?vue&type=script&setup=true&lang=js"
export * from "./reportSkzw.vue?vue&type=script&setup=true&lang=js"

import "./reportSkzw.vue?vue&type=style&index=0&id=4abe4a39&lang=less"

const __exports__ = script;

export default __exports__